import intlTelInput from "intl-tel-input";
import Inputmask from "inputmask";

class PhoneMaskCountry {
    constructor(el) {
        this.el = el;
        this.wrap = this.el.closest(".js-tel-input-country-wrap");
        this.label = this.wrap.querySelector(".js-tel-input-country-label");
        this.inputDeal = this.wrap.querySelector(".js-tel-input-country-dial");
        this.inputFull = this.wrap.querySelector(".js-tel-input-country-full");
        this.initTelInput();
        this.initMaskEvents();
    }

    initTelInput() {
        this.iti = intlTelInput(this.el, {
            initialCountry: "ru",
            autoHideDialCode: false,
            autoPlaceholder: "aggressive",
            separateDialCode: true,
            showSelectedDialCode: true,
            countrySearch: true,
            useFullscreenPopup: false,
            loadUtilsOnInit: "https://cdn.jsdelivr.net/npm/intl-tel-input@19.5.7/build/js/utils.js",
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@19.5.7/build/js/utils.js",
            customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
                if (selectedCountryData.iso2 === "ru") {
                    return "(XXX) XXX-XX-XX";
                }
                return "" + selectedCountryPlaceholder.replace(/[0-9]/g,"X");
            },
            i18n: {
                searchPlaceholder: "Country search"
            }
        });
        this.iti.promise.then(() => {
            this.initRealInput();
            this.setMask();
        });
    }

    initRealInput() {
        this.inputReal = document.createElement("input");
        this.inputReal.type = "text";
        this.inputReal.required = true;
        this.inputReal.name = this.el.dataset.nameReal;
        const classesList = this.el.dataset.classReal.split(" ");
        this.inputReal.classList.add(...classesList);
        const itl = this.wrap.querySelector(".iti");
        itl.appendChild(this.inputReal);
        this.el.classList.add(this.el.dataset.classMe);
        this.setPadding();

        this.inputReal.addEventListener("input", () => {
            this.setFullValue();
        });
    }

    initMaskEvents() {
        this.el.addEventListener("countrychange", () => {
            this.setMask();
            this.setPadding();
            this.inputDeal.value = "+" + this.iti.getSelectedCountryData().dialCode;
            this.setFullValue();
        });
    }

    setMask() {
        const placeholder = this.el.placeholder;
        let res = placeholder.replace( /X/g ,"9");
        if (this.iti.getSelectedCountryData().iso2 === "ru") {
            res = "(999) 999-99-99";
        }

        if (res !== "undefined") {
            this.mask = Inputmask({"mask": res, placeholder: "X", clearMaskOnLostFocus: false}).mask(this.inputReal);
        }
    }

    setPadding() {
        const padding = (this.wrap.querySelector(".iti__flag-container").offsetWidth + 6) + "px";
        this.label.style.paddingLeft = padding;
        this.inputReal.style.paddingLeft = padding;
    }

    setFullValue() {
        this.inputFull.value =  this.inputDeal.value + " " + this.inputReal.value;
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-tel-input-country")
        .forEach(input => new PhoneMaskCountry(input));
});
